/**
 * CRITICAL: Centralized logic for post-authentication dashboard redirects.
 *
 * DO NOT MODIFY THIS LOGIC WITHOUT A FULL SECURITY REVIEW.
 *
 * - This logic determines where users are sent after authentication.
 * - Client users must always be sent to /contacts/dashboard, regardless of DB user presence.
 * - Employee/Admin users must only be sent to /dashboard if their DB user is loaded.
 * - CRM users are sent to /access-denied.
 *
 * See: docs/authentication/COGNITO_SUB_ID_IMPORTANCE.md and docs/REDIRECT_LOGIC.md for details.
 */

export function getDashboardRedirectPath({
  isAuthenticated,
  isClientUser,
  isEmployee,
  isAdmin,
  user,
}: {
  isAuthenticated: boolean;
  isClientUser: boolean;
  isEmployee: boolean;
  isAdmin: boolean;
  user: any;
}) {
  if (!isAuthenticated) {
    return null;
  }

  if (isClientUser) {
    return "/contacts/dashboard";
  }

  if (isEmployee || isAdmin) {
    return "/dashboard";
  }

  // Fallback for unknown user types
  return null;
}
